import axios from "./axios"

const debugAccess = () => {
    return axios.get(`/debug/access`)
        .then(response => response.data)
}

const debugSwitch = (form) => {
    return axios.post(`/debug/switch`, form)
        .then(response => response.data)
}

export default {
    debugAccess,
    debugSwitch,
}